import { render } from "./ChatMessage.vue?vue&type=template&id=ebbde326&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=js"
export * from "./ChatMessage.vue?vue&type=script&lang=js"

import "./ChatMessage.vue?vue&type=style&index=0&id=ebbde326&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebbde326"]])

export default __exports__